import React from "react";

/**
 * FeatureCard — a generic value-prop card (icon + title + copy). NON-personal:
 * no balances, no "current" state, no claim action. Purely explanatory.
 *
 * Props:
 *   icon?        node   emoji string or an inline SVG/element (no file imports required)
 *   title        node
 *   description? node
 *   className?   str
 */
const FeatureCard = ({ icon, title, description, className = "" }) => {
  return (
    <div className={"teaser-feature" + (className ? ` ${className}` : "")}>
      {icon ? (
        <div className="teaser-feature__icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}
      {title ? <h3 className="teaser-feature__title">{title}</h3> : null}
      {description ? (
        <p className="teaser-feature__desc">{description}</p>
      ) : null}
    </div>
  );
};

export default FeatureCard;
